import { createAction } from '@reduxjs/toolkit';

import { SET_COMPLIANCE_LEVEL, type ComplianceLevel } from './types';

export const setComplianceLevel = createAction<ComplianceLevel, typeof SET_COMPLIANCE_LEVEL>(
	SET_COMPLIANCE_LEVEL,
);
